import { mirrorKeys } from 'utils/helpers';
import muiGridText from './muiGridText';
import mapDataKeys from './mapDataKeys';

const defaults = {
  logoutKey: '__logout__',
  tokenKey: '__tokenBackoffice__',
};

export const MODAL_TYPES = mirrorKeys([
  'infoModal',
  'warningModal',
  'errorModal',
  'successModal',
  'formModal',
  'viewClientModal',
  'duplicateDataModal',
  'bulkAddModal',
  'exportFileModal',
  'exportLinksModal',
  'confirmationModal',
]);

// TODO: move to constants
export const operationStatus = {
  initial: 'Inicial',
  pending: 'Pendiente',
  success: 'Éxito',
  failed: 'Rechazado',
  cancelled: 'Cancelado',
  signed: 'Firmado',
  viewed: 'Visto'
};

export const stateMap = {
  1: operationStatus.initial,
  2: operationStatus.pending,
  3: operationStatus.success,
  4: operationStatus.failed,
  5: operationStatus.cancelled,
  6: operationStatus.signed,
  7: operationStatus.viewed
};

export default defaults;
// re-exports
export const mapTableKeys = mapDataKeys;
export const tableLocaleText = muiGridText;
